import {
  setSelectedSourceEntities,
  setSelectedDestinationEntities,
} from '../state/slices/entitiesSlice';

export const updateSelectedEntitiesFromBackend = (
  dispatch,
  workflowId,
  entitySelections
) => {
  const sourceSelections = entitySelections?.source || {};
  const destinationSelections = entitySelections?.destination || {};

  Object.entries(sourceSelections).forEach(([key, entities]) => {
    dispatch(setSelectedSourceEntities({ workflowId, key, entities }));
  });

  Object.entries(destinationSelections).forEach(([key, entities]) => {
    dispatch(setSelectedDestinationEntities({ workflowId, key, entities }));
  });
};
